import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "react-bootstrap";
import { EditorState, convertFromRaw, convertToRaw } from "draft-js";
import CustomEditor from "../../../components/common/editor/CustomEditor.js";
import SimpleReactValidator from "simple-react-validator";
import { passageTypeService } from "../../../service/question/passageTypeService";
import { passageService } from "../../../service/question/passageService";
import { sweetStatusAlert } from "../../../components/common/SweetAlert";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";

export default class UpdatePassageModal extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    passage_id: null,
    title: "",
    description: "",
    passage_type_id: "",
    contentEditorState: EditorState.createEmpty(),
    passageTypes: [],
    isContentValid: true,
    isLoading: false,
  });

  componentDidMount() {
    this.getAllPassageTypes();
    if (this.props.passage) {
        const { passage_id, title, description, passage_type_id, content } = this.props.passage;
        const contentState = content
        ? EditorState.createWithContent(convertFromRaw(JSON.parse(content)[0]))
        : EditorState.createEmpty();
        
        this.setState({
            passage_id,
            title,
            description,
            passage_type_id,
            contentEditorState: contentState,
        });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && this.props.passage && this.props.passage !== prevProps.passage) {
      this.populateForm(this.props.passage);
    }
    if (!this.props.show && prevProps.show) {
      this.resetForm();
    }
  }

  getAllPassageTypes = async () => {
    this.setState({ isLoading: true });
    try {
      const response = await passageTypeService.getAllPassageTypes();
      if (response.success) {
        this.setState({ passageTypes: response.data.passage_types });
      } else {
        sweetStatusAlert("Failed!", "Error fetching Passage Types", "error");
      }
    } catch {
      sweetStatusAlert("Failed!", "Error fetching Passage Types", "error");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  populateForm = (passage) => {
    let contentEditorState = EditorState.createEmpty();
    try {
      if (passage.content) {
        const content = JSON.parse(passage.content);
        if (content?.[0]) {
          const contentState = convertFromRaw(content[0]);
          contentEditorState = EditorState.createWithContent(contentState);
        }
      }
    } catch {
      // fallback: empty state
    }

    this.setState({
      passage_id: passage.passage_id,
      title: passage.title || "",
      description: passage.description || "",
      passage_type_id: passage.passage_type_id || "",
      contentEditorState,
      isContentValid: true,
    });
    this.validator.hideMessages();
  };

  resetForm = () => {
    this.setState(this.getInitialState());
    this.validator.hideMessages();
  };

  validateContentEditor = () => {
    const contentState = this.state.contentEditorState?.getCurrentContent();
    const isValid = contentState && contentState.hasText();
    this.setState({ isContentValid: isValid });
    return isValid;
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleChangePassageType = (event) => {
    this.setState({ passage_type_id: event.target.value });
  };

  onContentEditorChange = (editorState) => {
    this.setState({ contentEditorState: editorState }, () => {
      this.validateContentEditor();
    });
  };

  handleUpdateSubmit = async () => {
    const isContentValid = this.validateContentEditor();
    const isFormValid = this.validator.allValid() && isContentValid;

    if (!isFormValid) {
      this.validator.showMessages();
      this.forceUpdate();
      return;
    }

    this.setState({ isLoading: true });

    const updated_by = sessionStorage.getItem("manage_user_id");
    const content = JSON.stringify([
      convertToRaw(this.state.contentEditorState.getCurrentContent()),
    ]);

    const updatedPassage = {
      title: this.state.title,
      content: content,
      description: this.state.description,
      passage_type_id: this.props.passageTypeId,
      created_by: updated_by,
    };

    const passageId = this.state.passage_id;

    try {
      const response = await passageService.updatePassage(updatedPassage, passageId);
      if (response.success) {
        sweetStatusAlert("Success!", response.message.success, "success");
        this.props.onSuccess(response.data);
        this.handleClose();
      } else {
        sweetStatusAlert("Failed!", response.message, "error");
      }
    } catch {
      sweetStatusAlert("Failed!", "Unable to update passage", "error");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleClose = () => {
    this.validator.hideMessages();
    this.validator.purgeFields();
    this.props.onClose();
  };

  render() {
    const { show } = this.props;
    const { isLoading, passage_id } = this.state;

    return (
      <>
        {isLoading && <PageSpinner id="show" text="Loading, Please wait!" />}

        <Modal show={show} onHide={this.handleClose} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>Edit Passage</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Form.Group as={Col} md="9">
                  <Form.Label>Title*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter title..."
                    name="title"
                    value={this.state.title}
                    onChange={this.handleChange}
                  />
                  {this.validator.message("title", this.state.title, "required|max:30", { className: "text-danger" })}
                </Form.Group>
              </Row>

              {/* <Row className="mb-3">
                <Form.Group as={Col} md="6">
                  <Form.Label>Passage Type*</Form.Label>
                  <Form.Select value={this.state.passage_type_id || ""} onChange={this.handleChangePassageType}>
                    <option value="" disabled hidden>Nothing Selected</option>
                    {this.state.passageTypes.map((option, index) => (
                      <option key={index} value={option.passage_type_id}>
                        {option.name}
                      </option>
                    ))}
                  </Form.Select>
                  {this.validator.message("passage_type", this.state.passage_type_id, "required", { className: "text-danger" })}
                </Form.Group>
              </Row> */}

              <Row className="mb-3">
                <Form.Group as={Col} md="12">
                  <Form.Label>Content*</Form.Label>
                  <div style={{ border: "1px solid #ced4da", borderRadius: "4px", padding: "10px", backgroundColor: "#fff" }}>
                    <CustomEditor
                      editorState={this.state.contentEditorState}
                      onEditorStateChange={this.onContentEditorChange}
                    />
                  </div>
                  {!this.state.isContentValid && <div className="text-danger mt-2">The content field is required.</div>}
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} md="9">
                  <Form.Label>Description*</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="description"
                    placeholder="Type description here..."
                    value={this.state.description}
                    onChange={this.handleChange}
                  />
                  {this.validator.message("description", this.state.description, "required|max:120", { className: "text-danger" })}
                </Form.Group>
              </Row>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            {passage_id && (
              <Button variant="primary" onClick={this.handleUpdateSubmit} disabled={isLoading}>
                Edit
              </Button>
            )}
            <Button variant="secondary" onClick={this.handleClose}>Close</Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
